import { useQuery } from '@tanstack/react-query';

const API_BASE = process.env.REACT_APP_API_BASE || '';

export interface SharedTripData {
  tripId: string;
  token: string;
  tripName: string;
  startDate: string;
  endDate: string;
  visitCount: number;
  isActive: boolean;
}

/**
 * Fetches shared trip data by its share link token.
 * Public endpoint — no authentication required.
 */
export function useViewShareLink(token: string) {
  return useQuery({
    queryKey: ['shared-trip', token],
    queryFn: async () => {
      const response = await fetch(`${API_BASE}/api/shares/${token}`);
      if (!response.ok) throw new Error(`Server error: ${response.status}`);
      return response.json() as Promise<SharedTripData>;
    },
    enabled: !!token,
  });
}
